import { useInsiderState } from "@faire/deprecated-retailer-visitor-shared/hooks/insider/useInsiderState";
import { useNationality } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useNationality";
import { useSettingInsiderMembershipPauseEnabled } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingInsiderMembershipPauseEnabled";
import { useSettingInsiderPhoneSuppportEnabled } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingInsiderPhoneSuppportEnabled";

export const useInsiderFeatureEligibility = () => {
  const { isAmerican, isCanadian, isEurope, isAustralian } = useNationality();

  const { isInsiderPausedOrWillPause, isInsiderTrial, isInsiderUnpaid } =
    useInsiderState();
  const isInsiderMembershipPauseEnabled =
    useSettingInsiderMembershipPauseEnabled();
  const isPhoneSupportEnabled = useSettingInsiderPhoneSuppportEnabled();

  const ignoreThresholdAdvertising = isCanadian || isAustralian;
  const hasFreeDutyAdvertising = isEurope;
  const hasPhoneSupport = isPhoneSupportEnabled;
  const hasReverseSeason = isAustralian;
  const hasProtectedEarlyAccessPerk = isAmerican || isCanadian || isAustralian;
  const hasSpecialTestimonial = isEurope;
  const hasSavingsBreakdown = isAmerican || isEurope;
  const hasNewPromoBanner = isCanadian || isAustralian;
  const hasMembershipTaxDisclaimer = isCanadian || isAustralian;
  const hasInsiderRefreshFAQs = isCanadian || isAustralian || isEurope;

  const hasPauseMembershipFeature =
    (isAmerican || isCanadian || isAustralian) &&
    isInsiderMembershipPauseEnabled;

  const canPauseMembership =
    hasPauseMembershipFeature &&
    !(isInsiderPausedOrWillPause || isInsiderTrial || isInsiderUnpaid);

  return {
    hasFreeDutyAdvertising,
    hasPhoneSupport,
    hasProtectedEarlyAccessPerk,
    hasSavingsBreakdown,
    hasSpecialTestimonial,
    hasReverseSeason,
    ignoreThresholdAdvertising,
    hasNewPromoBanner,
    hasMembershipTaxDisclaimer,
    hasPauseMembershipFeature,
    canPauseMembership,
    hasInsiderRefreshFAQs,
  };
};
